import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SLS_pedidosVendas {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  sanitizeParams(params) {
    if (!params || typeof params !== 'object') return undefined;
    const cleaned = {};
    Object.entries(params).forEach(([k, v]) => {
      if (v === undefined || v === null) return;
      if (typeof v === 'number' && isNaN(v)) return;
      if (v === '') return;
      cleaned[k] = v;
    });
    return Object.keys(cleaned).length ? cleaned : undefined;
  }

  getUserId() {
    try {
      const userData = JSON.parse(localStorage.getItem('userData'));
      return userData.userData?.id || null;
    } catch (error) {
      return null;
    }
  }

  async getPedidosVendas(params) {
    try {
      const userId = this.getUserId();
      let url = '/pedido-venda/listar';

      if (params && params.perfilTipo && params.perfilId) {
        url = `/pedido-venda/listar/${params.perfilTipo}/${params.perfilId}/${userId}`;

        const { perfilTipo, perfilId, ...queryParams } = params;
        params = queryParams;
      }

      const response = await this.api.get(url, { params });
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
    }
  }

  async getRascunhosPedidosVendas(params) {
    try {
      const userId = this.getUserId();
      let url = '/pedido-venda/listarRascunhos';

      if (params && params.perfilTipo && params.perfilId) {
        url = `/pedido-venda/listarRascunhos/${params.perfilTipo}/${params.perfilId}/${userId}`;

        const { perfilTipo, perfilId, ...queryParams } = params;
        params = queryParams;
      }

      const response = await this.api.get(url, { params });
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
    }
  }

  async listarCapaPedido(pedidoid) {
    try {
      const response = await this.api.get(`pedido-venda/listarCapaPedido/${pedidoid}`);
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
    }
  }

  async cancelarPedido(pedidoid) {
    try {
      const response = await this.api.post(`pedidos/cancelar/${pedidoid}`);
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
    }
  }

  async salvarItens(data) {
    // console.log(data);
    try {
      const response = await this.api.post('pedidos/editarItensPedidoVenda', {
        dataPedido: data.dataPedido,
        itens: data.itens,
      });
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
    }
  }

  async enderecoEntregaPedido(clienteid) {
    try {
      const response = await this.api.get(`pedido-venda/enderecoEntrega/${clienteid}`);
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
    }
  }

  async itensPedido(pedidoid) {
    try {
      const response = await this.api.get(`pedido-venda/itens/${pedidoid}`);
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
    }
  }

  async itensMarcaPedido(precoId) {
    try {
      const response = await this.api.get(`pedido-venda/marca/${precoId}`);
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
    }
  }

  async itensCategoriaPedido(cod_marca) {
    try {
      const response = await this.api.get(`pedido-venda/categoria/${cod_marca}`);
      return response.data;
    } catch (error) {
      this.error.message(error);
    }
  }

  async itensReferenciaPedido(codmarca, codcategoria) {
    try {
      const response = await this.api.get(`pedido-venda/referencia/codmarca/${codmarca}/codCategoria/${codcategoria}`);
      return response.data;
    } catch (error) {
      this.error.message(error);
    }
  }

  async itensEmbalagemPedido(fml_comercialId, precoId) {
    try {
      const response = await this.api.get(`pedido-venda/embalagem/${fml_comercialId}/precoId/${precoId}`);
      return response.data;
    } catch (error) {
      this.error.message(error);
    }
  }

  async itensImagemPedido(codmarca, familia_comercial) {
    try {
      const response = await this.api.get(`pedido-venda/imagens/${codmarca}/familia_comercial/${familia_comercial}`);
      return response.data;
    } catch (error) {
      this.error.message(error);
    }
  }

  async precoItemPedido(tabelaPrecoId, item) {
    try {
      const response = await this.api.get(`tabela-preco-item/tabelapreco/${tabelaPrecoId}/item/${item}`);
      return response.data;
    } catch (error) {
      this.error.message(error);
    }
  }

  async ItemPedido(cod_marca, cod_categ, familia_comercial) {
    try {
      const response = await this.api.get(`pedido-venda/item-pedido/cod-marca/${cod_marca}/cod-categ/${cod_categ}/familia-comercial/${familia_comercial}`);
      return response.data;
    } catch (error) {
      this.error.message(error);
    }
  }

  async buscarReferenciaPorCodigo(codReferencia, tabelaPrecoId) {
    try {
      const response = await this.api.get(`/pedido-venda/referencia/buscar/${codReferencia}/precoId/${tabelaPrecoId}`);
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
    }
  }
}
